import { UserS3UploadSignature } from './types';

export const selectUserId = (state) => state.user.id;

export const selectFeatureFlip = (state, featureFlip) =>
  state?.user?.features?.includes(featureFlip);

export const selectWeekStartsMonday = (state) =>
  !!state.user?.week_starts_monday;

export const selectHasTwentyFourHourTimeFormat = (state) =>
  state.user?.hasTwentyFourHourTimeFormat;

export const selectUserHasFeature = (state, feature) =>
  state?.user?.features?.includes(feature);

export const selectImageDimensionsKey = (state) =>
  state?.user?.imageDimensionsKey;

export const selectS3Signature = (state): UserS3UploadSignature =>
  state?.user?.s3_upload_signature;

export const selectUserIdAndEmail = (state) => {
  return {
    id: state.user.id,
    email: state.user.email,
  };
};
